import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import api from '@/apiRequest';
import { showToast } from '@/store/ducks/toasts';

export const useInspectorAppSettings = (inspectorId) => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  const intl = useIntl();

  const queryKey = ['inspectorAppSettings', inspectorId];

  // Query: Fetch inspector app settings
  const settingsQuery = useQuery({
    queryKey,
    queryFn: async () => {
      const { data } = await api.get(`/inspectors/${inspectorId}/app-settings`);
      return data;
    },
    enabled: Boolean(inspectorId),
  });

  // Mutation: Update inspector app settings
  const updateSettingsMutation = useMutation({
    mutationFn: async (payload) => {
      const { data } = await api.put(`/inspectors/${inspectorId}/app-settings`, payload);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
      dispatch(
        showToast({
          type: 'success',
          title: intl.formatMessage({ id: 'SUCCESS' }),
          text: intl.formatMessage({ id: 'APP_SETTINGS_SAVE_SUCCESS' }),
          duration: 5000,
        })
      );
    },
    onError: (err) => {
      console.error(err);
      dispatch(
        showToast({
          type: 'error',
          title: intl.formatMessage({ id: 'ERROR' }),
          text: intl.formatMessage({ id: 'APP_SETTINGS_SAVE_ERROR' }),
          duration: 5000,
        })
      );
    },
  });

  return {
    appSettingsData: settingsQuery.data,
    isLoading: settingsQuery.isLoading,
    isError: settingsQuery.isError,
    error: settingsQuery.error,
    refetch: settingsQuery.refetch,
    updateSettings: updateSettingsMutation,
  };
};
